"use client";

import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui/material";
import React, { type ReactNode } from "react";
import { MOBILE_APPBAR_HEIGHT, PLAYGROUND_DESKTOP_APP_BAR_HEIGHT } from "#/features/appBar/constants";
import { usePlaygroundMobileLayout } from "#/features/playground/hooks/usePlaygroundMobileLayout";
import { usePlaygroundPanelsReady } from "#/features/playground/hooks/usePlaygroundPanelsReady";
import { PlaygroundPanelsSkeleton } from "#/features/playground/ui/PlaygroundPanelsSkeleton";
type PlaygroundPanelsGateProps = {
  children: ReactNode;
};

/**
 * Keeps one continuous panel skeleton from route loading through client hydration.
 * Panels mount underneath (opacity 0) so editors can finish init before reveal.
 */
export const PlaygroundPanelsGate: React.FC<PlaygroundPanelsGateProps> = t0 => {
  const $ = _c(15);
  const {
    children
  } = t0;
  const isMobile = usePlaygroundMobileLayout();
  const panelsReady = usePlaygroundPanelsReady();
  const panelAreaMinHeight = isMobile ? `calc(100vh - ${MOBILE_APPBAR_HEIGHT}px - env(safe-area-inset-top, 0px))` : `calc(100vh - ${PLAYGROUND_DESKTOP_APP_BAR_HEIGHT}px)`;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      position: "relative"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== panelsReady) {
    t2 = !panelsReady ? <Box sx={{
      position: "absolute",
      inset: 0,
      zIndex: 2
    }}><PlaygroundPanelsSkeleton /></Box> : null;
    $[1] = panelsReady;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = !panelsReady;
  const t4 = !panelsReady;
  const t5 = panelsReady ? 1 : 0;
  const t6 = panelsReady ? "auto" : "none";
  let t7;
  if ($[3] !== panelAreaMinHeight || $[4] !== t5 || $[5] !== t6) {
    t7 = {
      minHeight: panelAreaMinHeight,
      opacity: t5,
      pointerEvents: t6
    };
    $[3] = panelAreaMinHeight;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== children || $[8] !== t3 || $[9] !== t4 || $[10] !== t7) {
    t8 = <Box aria-busy={t3} aria-hidden={t4} sx={t7}>{children}</Box>;
    $[7] = children;
    $[8] = t3;
    $[9] = t4;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t2 || $[13] !== t8) {
    t9 = <Box sx={t1}>{t2}{t8}</Box>;
    $[12] = t2;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
};